import { ComponentType, lazy } from "react";

const lazyWithRetry = <P = unknown>(
  componentImport: () => Promise<{ default: ComponentType<P> }>,
) => {
  return lazy(async () => {
    const hasPageReloaded = sessionStorage.getItem("page-reloaded") === "true";

    try {
      const component = await componentImport();
      sessionStorage.setItem("page-reloaded", "false");
      return component;
    } catch (error) {
      // Don't retry during orientation changes to avoid interrupting the process
      const isOrientationChanging = document.documentElement.classList.contains(
        "orientation-changing",
      );

      console.log("Lazy component failed to load", {
        error: error instanceof Error ? error.message : String(error),
        isOrientationChanging,
        hasPageReloaded,
      });

      if (!hasPageReloaded && !isOrientationChanging) {
        console.log("Triggering page reload for lazy component retry");
        sessionStorage.setItem("page-reloaded", "true");
        window.location.reload();
        // Return a pending promise to satisfy TypeScript
        return new Promise<never>(() => {});
      } else {
        console.log(
          "Skipping reload - either already reloaded or during orientation change",
        );
        sessionStorage.setItem("page-reloaded", "false");
        throw error;
      }
    }
  });
};

export default lazyWithRetry;
